<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="4">
        <template v-slot:thead>
          <tr>
            <th scope="col" :sortable="resourceState.sort" :col="'label'" @click="applySort">{{ $t('labels.name') }}</th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ r.label }}</td>
          <td>{{ $t('labels.frames.' + r.frame) }}</td>
          <td>{{ $n(r.amount, 'currency') }}</td>
          <td class="t2">
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'label'" :label="$t('labels.name')" v-model="resource.label" :error="slotProps.error"></input-field>
          <radio-slider :name="'frame'" :label="$t('labels.frame')" v-model="resource.frame" :options="{'week': $t('labels.frames.week'), 'month': $t('labels.frames.month'), 'annual': $t('labels.frames.annual')}"></radio-slider>
          <input-field :type="'integer'" :name="'name'" :label="$t('labels.amount')" v-model="resource.amount" :error="slotProps.error"></input-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'Budgets',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'coins'],
      resource: {
        label: '',
        frame: '',
        amount: 0
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.budgets,
      resourceState: state => state.budgetsState,
      resourceStore: state => state.budgetsStore
    })
  }
}
</script>
